// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__Container___1fc1i{height:0;left:0;top:0}.index__Container___1fc1i,.index__FixedContainer___FQ93q{pointer-events:none;position:relative;width:100%;z-index:100000}.index__Notification___BSY7a{display:flex;justify-content:center;left:50%;margin:auto;position:absolute;width:100%;z-index:3000}.index__NotificationToast___2hKno{max-width:700px;pointer-events:all}.index__NotificationBannerWrapper___1Gias{display:flex;justify-content:center;margin:auto;width:100%;z-index:3000}.index__NotificationBanner___1ltXM{border-radius:0;pointer-events:all;width:100%}.index__NotificationToastMobile___2tUEy{max-width:calc(100% - 28px);pointer-events:all}", ""]);
// Exports
exports.locals = {
	"Container": "index__Container___1fc1i",
	"FixedContainer": "index__FixedContainer___FQ93q",
	"Notification": "index__Notification___BSY7a",
	"NotificationToast": "index__NotificationToast___2hKno",
	"NotificationBannerWrapper": "index__NotificationBannerWrapper___1Gias",
	"NotificationBanner": "index__NotificationBanner___1ltXM",
	"NotificationToastMobile": "index__NotificationToastMobile___2tUEy"
};
module.exports = exports;
